// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"8fb60229","328":"c8db1b3a","360":"8fb60229","528":"54dcf8dc","535":"2a70d628","700":"38b8d9d4","864":"c36a07d6","970":"a8691c82"}[chunkId] + ".chunk.css";
};